<template>
  <div class="loginWrapper">
    <div class="loginLeftSide">
      <router-view v-on:openSignUpTos="openSignUpTos" v-on:openSignUpRegCertModal="openSignUpRegCertModal"></router-view>
    </div>
    <div class="loginRightSide">
      <img class="loginBackgroundImg" v-bind:src="backgroundImg">
      <span class="versionInfo">{{'  ver. ' + $store.getters.getVersion}}</span>
    </div>
  </div>
</template>

<script>
export default {
  data () {
    return {
      backgroundImg: require('@/assets/img/login_background.png')
    }
  },
  methods: {
    openSignUpTos: function (payload) {
      this.$emit('openSignUpTos', {index: payload.index, optionName: payload.optionName})
    },
    openSignUpRegCertModal: function () {
      this.$emit('openSignUpRegCertModal')
    }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
.loginWrapper{
  position: absolute;
  left: 50%;
  top: 50%;
  transform: translate(-50%, -50%);
  margin: auto;
  height: 50%;
  width: 100%;
}

.loginLeftSide{
  float: left;
  width: 45%;
  height: 100%;
  margin-left: 24px;
}

.loginRightSide{
  position: relative;
  float: right;
  width: 50%;
  height: 100%;
  margin: auto;
  text-align: right;
}

.loginRightSide > .versionInfo {
  font-size: 14px;
}

.loginBackgroundImg{
  width: 595px;
  height: 443px;
}

</style>



// WEBPACK FOOTER //
// src/components/login/views/login.vue